export default __webpack_public_path__ + "static/media/Automation_Leadspaces_FINAL_Services.dabf278d.svg";